import WithLayout from '../WithLayout';
import { ArticleWrapper } from './ArticleWrapper';

export default WithLayout(ArticleWrapper);
